import { createSelector } from '@reduxjs/toolkit';
import { selectModel } from '../../store/selectors';

export const selectCommonDetails = createSelector(selectModel, (modelState) => modelState.common);

export const selectCommonModelStatus = createSelector(selectCommonDetails, (commonState) => commonState.currentModelStatus);
export const selectCommonModelVersionId = createSelector(selectCommonDetails, (commonState) => commonState.currentModelVersionId);
export const selectCommonModelId = createSelector(selectCommonDetails, (commonState) => commonState.currentModelId);
export const selectCommonModelHasEditModelAccess = createSelector(selectCommonDetails, (commonState) => commonState.hasEditModelAccess);
